<template>
  <fts-design-modal
    class="fts-form-formula-modal"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <i
          :class="informationIcon"
          class="design-modal-header-icon information-icon"
          v-if="informationIcon"
        />
        <div class="design-modal-header-name">
          {{ title }}
        </div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <div class="design-modal-header-description form-formula-modal-sub">Formula &amp; behavior</div>
    </template>
    <!-- body -->
    <template #body>
      <fts-field-behavior-ledger
        ref="ledger"
        :form-data="formData"
        :variables="variables"
        :form="form"
        :actions="actions"
        :information-formula="informationFormula"
        :is-computed="injectedComputed"
        :is-parent-formula-mode="isParentFormulaMode"
        :activity-id="activityId"
        :parent-name="parentName"
      />
    </template>
    <!-- footer:right -->
    <template #footerRight>
      <fts-btn text @click="beforeClose">
        Cancel
      </fts-btn>
      <fts-btn color="primary" outline @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import changesets from "diff-json";
import commons from '../commons/commons';

import FTSDesignModal from './FTSDesignModal';
import FTSFieldBehaviorLedger from './FTSFieldBehaviorLedger';
import FTSBtn from '../elements/FTSBtn';

export default {
  components: {
    'fts-design-modal': FTSDesignModal,
    'fts-field-behavior-ledger': FTSFieldBehaviorLedger,
    'fts-btn': FTSBtn
  },
  data: () => ({
    variables: null,
    form: null,
    actions: null,
    informationFormula: null,
    isParentFormulaMode: false,
    injectedComputed: false,
    formData: null,
    originalData: null,
    resolve: null,
    /* engine-badge context (proposal §6): the activity whose form is being designed, and — when
       editing a table COLUMN's formulas — the table's display name. */
    activityId: null,
    parentName: null
  }),
  methods: {
    async show({ formData, variables, form, actions, informationFormula, isComputed, isParentFormulaMode, activityId, parentName }) {
      this.variables = _.cloneDeep(variables);
      this.form = _.cloneDeep(form);
      this.actions = Array.isArray(actions) ? _.cloneDeep(actions) : [];
      this.informationFormula = _.cloneDeep(informationFormula);
      this.injectedComputed = Boolean(isComputed);
      this.isParentFormulaMode = Boolean(isParentFormulaMode);
      this.activityId = activityId || null;
      this.parentName = parentName || null;
      this.formData = _.cloneDeep(formData);

      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData);
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.close();
                    },
                  }
                ]
              })
            } else {
              this.close();
            }
          }
        });
        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
        });
      });
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    close() {
      this.$refs.ftsDesignModal.close();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    done() {
      this.$refs.ledger && this.$refs.ledger.finalize();
      this.resolve && this.resolve(this.formData);
      this.close();
    }
  },
  computed: {
    title() {
      if (this.formData.input === 'section') {
        if (this.formData.type === 'tab') {
          return 'Tab';
        } else if (this.formData.header) {
          return this.formData.header;
        } else if (this.formData.type === 'collapse') {
          return 'Collapse';
        } else if (this.formData.type === 'column') {
          return 'Column';
        } else {
          return 'Section';
        }
      } else if (this.formData.input === 'empty') {
        return 'Empty';
      } else if (this.formData.input === 'button') {
        return this.formData.label || 'Button';
      } else if (this.formData.input === 'image') {
        return 'Image';
      }
      return this.formData.displayName;
    },
    informationIcon() {
      if (!['description', 'image', 'empty', 'button', 'section'].some((x) => x == this.formData.input))
        return commons.informationIcon(this.formData.type);
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-form-formula-modal {
  .form-formula-modal-sub {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
</style>
